import { render, staticRenderFns } from "./SingleSelectColor.vue?vue&type=template&id=369f52ac&scoped=true&"
import script from "./SingleSelectColor.vue?vue&type=script&lang=js&"
export * from "./SingleSelectColor.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelectColor.vue?vue&type=style&index=0&id=369f52ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f52ac",
  null
  
)

export default component.exports